import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JsonConverterUtils {
  public JsonParsed(message: string): any | null {
    let jsonParsed: any = {};

    try {
      jsonParsed = JsonConverterUtils.exportJsonParsed(message);
    } catch {
      jsonParsed = {};
    }

    return jsonParsed;
  }

  public JsonStringfy(objetcJson: any): any | null {
    let jsonStringfy: string = '';

    try {
      jsonStringfy = JSON.stringify(objetcJson);
    } catch {
      jsonStringfy = '';
    }

    return jsonStringfy;
  }

  public static exportJsonParsed<T = unknown>(text: string): T | null {
    try {
      return JSON.parse(text);
    } catch {
      return JSON.parse(
        text
          .replace(/([{,]\s*)'([^']+?)'\s*:/g, '$1"$2":')
          .replace(/:\s*'([^']*?)'/g, ':"$1"'),
      );
    }
  }
}
